import classNames from 'classnames';
import React, {FC} from 'react';

import './index.css';

interface SnapLogoProps {
  large?: boolean;
}

const SnapLogo: FC<SnapLogoProps> = props => {
  const {large = false} = props;
  return (
    <div className={classNames(['SnapLogo', {SnapLogo__small: !large}])}>
      <div className="SnapLogo--inner-wrapper">
        <div className="SnapLogo--icon">
          <i className="fa-solid fa-camera" />
          <span className="SnapLogo--camera-circle" />
        </div>
        <h1 className={'SnapLogo--mainText'}>
          Snap <span className="SnapLogo--beta">Beta</span>
        </h1>
        {large && <p className="SnapLogo--subText">Powered by Macmillan</p>}
      </div>
    </div>
  );
};

SnapLogo.displayName = 'SnapLogo';

export default SnapLogo;
